import React from "react";
import { Link } from "react-router-dom";
import { getForgottenPasswordLink } from "utils/urls";

const ForgottenPasswordLink = () => (
  <Link
    id="reset-link"
    to={getForgottenPasswordLink()}
    className="ln-c-button ln-c-button--filled ln-c-button--full"
    style={{ maxWidth: "20rem" }}
  >
    Reset your password
  </Link>
);

export default ForgottenPasswordLink;
